import { mappingFunction } from "../../plugins/mappingBaseRef";
// import Vue from "vue";
import { reactive } from "vue";
import baseRef from "./baseRef";
import cats from "@/api/categories";
import journey from "@/api/journey";
import results from "@/api/results";
import powerpoint from "@/api/powerpoint";

const state = {
  selections: {},
  selection: {},
  variables: {},
  getResults: {},
  dataTableResults: {},
  nonEmpty: {},
  selectionJourney: {},
  html: "",
  name: "",
  isLoading: true,
  fromDB: false,
};

const mutations = {
  select(state, item) {
    state.selection = item;
  },
  getVariables(state, selection) {
    state.variables = selection;
  },
  getJourneyResults(state, variables) {
    state.getResults = variables;
  },
  getJourneyResultTable(state, variables) {
    state.dataTableResults = variables;
  },
  getName(state, nameJourney) {
    state.name = nameJourney;
  },
  getAll(state, input) {
    state.selections = input;
  },
  getHtml(state, text) {
    state.html = text;
  },
  loadingTrue(state) {
    state.isLoading = true;
  },
  loadingFalse(state) {
    state.isLoading = false;
  },
  databaseRecord(state) {
    state.fromDB = true;
  },
  sendResults(state) {
    const mapping = {
      archetypes: "archetypen",
      onderstromen: "onderstromen",
      valuesCards: "waardekaarten",
      lifestyle: "lifestyle",
      brands: "merken",
      sustainability: "duurzaamheid",
      politics: "politiek",
      media: "media",
      persuasionTactics: "overtuigingsstrategieën",
      mentality_milieus: "mentality",
      fintality_milieus: "fintality",
      burgerschapsstijlen_milieus: "burgerschapsstijlen",
      shoppermentality_milieus: "shoppermentality",
      vitality_milieus: "vitality",
      zorgmentality_milieus: "zorgmentality",
      vijftintengroener_milieus: "vijftintengroener",
      vrijetijdsprofielen_milieus: "vrijetijdsprofielen",
      socioDemographics: "demografie",
      "Geslacht = Vrouw": "Vrouw",
      "Geslacht = Man": "Man",
      "Leeftijd = 18-24": "18-24",
      "Leeftijd = 25-34": "25-34",
      "Leeftijd = 35-44": "35-44",
      "Leeftijd = 45-54": "45-54",
      "Leeftijd = 55-65": "55-65",
      "Leeftijd = 66-80": "66-80",
      "Regio = 3 grote gemeenten: Amsterdam, Rotterdam, Den Haag":
        "Amsterdam, Rotterdam en Den Haag",
      "Regio = Randgemeenten": "Randgemeenten",
      "Regio = Noord": "Noord",
      "Regio = Oost": "Oost",
      "Regio = West": "West",
      "Regio = Zuid": "Zuid",
      "Opleiding = Laag": "Laag opgeleid",
      "Opleiding = Midden": "Middelbaar opgeleid",
      "Opleiding = Hoog": "Hoog opgeleid",
      "Leefsituatie = Getrouwd": "Getrouwd",
      "Leefsituatie = Samenwonend": "Samenwonend",
      "Leefsituatie = Gescheiden": "Gescheiden",
      "Leefsituatie = Uit elkaar": "Uit elkaar",
      "Leefsituatie = Weduwe/weduwnaar": "Weduwe/weduwnaar",
      "Leefsituatie = Alleenstaand": "Alleenstaand",
      "Leefsituatie = Niet samenwonend, wel in een relatie (LAT-relatie)":
        "Niet samen-wonend, wel in relatie (LAT-relatie)",
      "Kinderen = Wel kinderen": "Wel kinderen",
      "Kinderen = Geen kinderen": "Geen kinderen",
      "Inkomen = Laag": "Laag inkomen",
      "Inkomen = Midden": "Gemiddeld inkomen",
      "Inkomen = Hoog": "Hoog inkomen",
      "Werkzaamheid = Zelfstandig ondernemer": "Zelfstandig ondernemer",
      "Werkzaamheid = Voltijd in (loon)dienst": "Voltijd in (loon)dienst",
      "Werkzaamheid = Deeltijd in (loon)dienst (< 30 uur/week)":
        "Deeltijd in (loon)dienst (< 30 uur/week)",
      "Werkzaamheid = Werkloos, arbeidsongeschikt":
        "Werkloos, arbeidsongeschikt",
      "Werkzaamheid = Huisman/huisvrouw": "Huisman/huisvrouw",
      "Werkzaamheid = Student": "Student",
      "Werkzaamheid = Gepensioneerd": "Gepensioneerd",
    };
    const result = {};
    // Basegroup
    const baseGroup = reactive({});
    state.variables.filters.forEach((category) => {
      result[mapping[category.category]] = [];
      category.selections.forEach((item) => {
        if (item.key != "" && item.value != "") {
          if (category.category === "socioDemographics") {
            result[mapping[category.category]].push({
              checked: true,
              tagName: mapping[item.value],
              value: item.key,
            });
          } else {
            result[mapping[category.category]].push({
              checked: true,
              tagName: item.value,
              value: item.key,
            });
          }
          // Vue.set(
          //   baseGroup,
          //   mapping[category.category],
          //   result[mapping[category.category]]
          // );
          // Last Change
          baseGroup[mapping[category.category]] =
            result[mapping[category.category]];
          baseRef.state.baseGroup = baseGroup;
        }
      });
    });
    // Referencegroup
    const referenceGroup = {};
    state.variables.references.forEach((category) => {
      result[mapping[category.category]] = [];
      category.selections.forEach((item) => {
        if (item.key != "" && item.value != "") {
          if (category.category === "socioDemographics") {
            result[mapping[category.category]].push({
              checked: true,
              tagName: mapping[item.value],
              value: item.key,
            });
          } else {
            result[mapping[category.category]].push({
              checked: true,
              tagName: item.value,
              value: item.key,
            });
          }
          // Vue.set(
          //   referenceGroup,
          //   mapping[category.category],
          //   result[mapping[category.category]]
          // );
          // Last Change
          referenceGroup[mapping[category.category]] =
            result[mapping[category.category]];
          baseRef.state.referenceGroup = referenceGroup;
        }
      });
    });
  },
};

const actions = {
  exportAllInfoJourney({ commit, state }) {
    // commit("loadingTrue");
    const params = mappingFunction(
      baseRef.state.baseGroup,
      baseRef.state.referenceGroup
    );
    const saved = Object.assign({}, params, { journeyName: state.name });
    commit("getAll", saved);

    powerpoint.fullExport(saved).then((res) => {
      commit("getHtml", res.data);
      let blob = new Blob([state.html], { type: "application/vnd.ms-excel" });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, state.name + ".xls");
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = state.name + ".xls";
        link.click();
      }
      commit("loadingFalse");
    });
  },
  exportAllInfoPowerpointJourney({ commit, state }) {
    commit("loadingTrue");
    const params = mappingFunction(
      baseRef.state.baseGroup,
      baseRef.state.referenceGroup
    );
    const saved = Object.assign({}, params, { journeyName: state.name });
    commit("getAll", saved);
    powerpoint.fullExportPowerpoint(saved).then((res) => {
      let blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, state.name + ".pptx");
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = state.name + ".xls";
        link.click();
      }
      commit("loadingFalse");
    });
  },
  exportAiCommunicationTestJourney({ commit, state }) {
    const params = mappingFunction(
      baseRef.state.baseGroup,
      baseRef.state.referenceGroup
    );
    const saved = Object.assign({}, params, { journeyName: state.name });
    commit("getAll", saved);
    return saved;
  },
  getAllSelections({ commit }) {
    commit("loadingTrue");
    journey.getAllJourneys().then((res) => {
      commit("getAll", res.data.historyItem);
      commit("loadingFalse");
    });
  },
  createSelection({ commit }, item) {
    commit("getName", item.name);
    const params = mappingFunction(item.base, item.ref);
    const saved = Object.assign({}, params, { journeyName: item.name });
    commit("select", saved);
    journey.createJourney(saved);
  },
  editSelection({ commit }, names) {
    // send old JourneyName and new JourneyName
    commit("getName", names);
    journey.editJourney({
      journey: names.oldJourneyName + "|" + names.newJourneyName,
    });
  },
  getSelection({ commit, state }, nameJourney) {
    // send JourneyName as journey^date => api will return filters => put filters in url
    commit("getName", nameJourney);
    journey.getJourney({ journey: nameJourney }).then((res) => {
      let selection = res.data;
      commit("getVariables", selection);
      commit("getJourneyResults", state.variables);
      commit("sendResults", selection);
      const params = mappingFunction(
        baseRef.state.baseGroup,
        baseRef.state.referenceGroup
      );
      cats.counter(params).then((res) => {
        let base = res.data.split(",");
        baseRef.state.calc.base = base[0];
        baseRef.state.calc.reference = base[1];
      });
    });
  },
  deleteSelection({ commit }, nameJourney) {
    // send journeyName
    commit("getName", nameJourney);
    journey.deleteJourney({ journey: nameJourney });
  },
  getResultsJourney({ commit }, category) {
    const params = mappingFunction(
      baseRef.state.baseGroup,
      baseRef.state.referenceGroup
    );

    commit("getJourneyResults", {});
    commit("getJourneyResultTable", {});
    switch (category) {
      case "archetypen":
        results.resultsArchetypes(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "merken":
        results.resultsBrands(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "duurzaamheid":
        results.resultsSustainability(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "lifestyle":
        results.resultsLifestyle(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "media":
        results.resultsMedia(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "overtuigingsstrategieën":
        results.resultsPersuasion(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "politiek":
        results.resultsPolitics(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "demografie":
        results.resultsDemographics(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "onderstromen":
        results.resultsUndercurrent(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "waardekaarten":
        results.resultsValuesCards(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "mentality":
        results.resultsMentality(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "shoppermentality":
        results.resultsShopperMentality(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "fintality":
        results.resultsFintality(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "burgerschapsstijlen":
        results.resultsBurgerschapsstijlen(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "vijftintengroener":
        results.resultsVijfTintenGroener(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "vitality":
        results.resultsVitality(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "vrijetijdsprofielen":
        results.resultsVrijetijdsprofielen(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "zorgmentality":
        results.resultsZorgMentality(params).then((res) => {
          commit("databaseRecord");
          commit("getJourneyResults", res.data);
          commit("getJourneyResultTable", res.data);
        });
        break;
    }
  },
  getJourneyResultsSort({ commit }, data) {
    data.cat, data.pageName;
    const params = mappingFunction(
      baseRef.state.baseGroup,
      baseRef.state.referenceGroup
    );
    let saved = {};
    if (data.cat === "") {
      saved = Object.assign({}, params);
    } else {
      saved = Object.assign({}, params, {
        getDataTable: true,
        dataTableTopic: data.cat,
      });
    }
    commit("getJourneyResultTable", {});
    switch (data.pageName) {
      case "merken":
        results.resultsBrandsSort(saved).then((res) => {
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "duurzaamheid":
        results.resultsSustainabilitySort(saved).then((res) => {
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "lifestyle":
        results.resultsLifestyleSort(saved).then((res) => {
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "media":
        results.resultsMediaSort(saved).then((res) => {
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "overtuigingsstrategieën":
        results.resultsPersuasionSort(saved).then((res) => {
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "politiek":
        results.resultsPoliticsSort(saved).then((res) => {
          commit("getJourneyResultTable", res.data);
        });
        break;
      case "demografie":
        results.resultsDemographicsSort(saved).then((res) => {
          commit("getJourneyResultTable", res.data);
        });
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
